import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { contactsApi } from '../../../api/adminApi';
import './ContactView.css';

function ContactView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError('');
    contactsApi
      .getOne(id)
      .then((data) => setContact(data))
      .catch((err) => setError(err.userMessage || 'Failed to load contact'))
      .finally(() => setLoading(false));
  }, [id]);

  const formatDate = (str) => {
    if (!str) return '—';
    try {
      const d = new Date(str);
      return isNaN(d.getTime()) ? str : d.toLocaleDateString(undefined, { dateStyle: 'long' });
    } catch {
      return str;
    }
  };

  const field = (label, value) => (
    <div key={label} className="admin-contact-view-row">
      <dt>{label}</dt>
      <dd>{value ?? '—'}</dd>
    </div>
  );

  if (loading) {
    return <div className="admin-contact-view-loading">Loading contact…</div>;
  }

  if (error || !contact) {
    return (
      <div className="admin-contact-view">
        <div className="admin-contact-view-header">
          <Link to="/admin/contacts" className="admin-contact-view-back">← Contacts</Link>
        </div>
        <div className="admin-contact-view-error" role="alert">
          {error || 'Contact not found.'}
        </div>
      </div>
    );
  }

  const title = contact.label ?? contact.name ?? contact.type ?? contact.contact_type ?? 'Contact';

  return (
    <div className="admin-contact-view">
      <div className="admin-contact-view-header">
        <Link to="/admin/contacts" className="admin-contact-view-back">← Contacts</Link>
        <h2>{title}</h2>
        <div className="admin-contact-view-actions">
          <button
            type="button"
            className="admin-contact-view-btn admin-contact-view-btn-edit"
            onClick={() => navigate('/admin/contacts', { state: { editContact: contact } })}
          >
            Edit
          </button>
        </div>
      </div>

      <div className="admin-contact-view-card">
        <dl className="admin-contact-view-details">
          {field('Type', contact.type ?? contact.contact_type)}
          {field('Label', contact.label ?? contact.name)}
          <div className="admin-contact-view-row admin-contact-view-row--value">
            <dt>Value</dt>
            <dd className="admin-contact-view-value">
              {contact.type === 'email' || contact.contact_type === 'email' ? (
                <a href={`mailto:${contact.value ?? contact.content ?? contact.url}`}>
                  {contact.value ?? contact.content ?? contact.url}
                </a>
              ) : contact.type === 'phone' || contact.contact_type === 'phone' ? (
                <a href={`tel:${(contact.value ?? contact.content ?? contact.url ?? '').replace(/\D/g, '')}`}>
                  {contact.value ?? contact.content ?? contact.url}
                </a>
              ) : (
                contact.value ?? contact.content ?? contact.url ?? '—'
              )}
            </dd>
          </div>
          {field('Display order', contact.display_order ?? contact.displayOrder)}
          {field('Created', formatDate(contact.created_at ?? contact.createdAt))}
        </dl>
      </div>
    </div>
  );
}

export default ContactView;
